import { DashboardConstants } from '../../actions/constant';

const {
  POST_DASHBOARD_CHECKOUT_RESET,
  POST_DASHBOARD_CHECKOUT_SUCCESS,
  POST_DASHBOARD_CHECKOUT_FAILURE,
  POST_DASHBOARD_CHECKOUT_LOADER,
  POST_DASHBOARD_CHECKOUT_RESET_LOGOUT,
  CLOCK_ACTION,
  POST_DASHBOARD_CHECKOUT_REQUEST,
  POST_CHECKOUT_ACTION_RESET,
} = DashboardConstants;
const intitialstate: object = {
  response: null,
  isGetCheckIn: false,
  loading: false,
  isUpdated: false,
  clockAction: null,
  idleTimeExpired: false,
};

export const checkoutReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case POST_DASHBOARD_CHECKOUT_SUCCESS: {
      return {
        ...state,
        isGetCheckIn: true,
        response: action.payload,
        loading: false,
        clockAction: action.action,
        isUpdated: action?.isLogout,
      };
    }

    case POST_DASHBOARD_CHECKOUT_FAILURE:
      return {
        ...state,
        isGetCheckIn: false,
        response: action.payload,
        loading: false,
        isUpdated: false,
      };
    case POST_DASHBOARD_CHECKOUT_REQUEST:
      return {
        ...state,
        isLogout: action.payload?.isLogout,
      };
    case POST_DASHBOARD_CHECKOUT_LOADER:
      return {
        ...state,
        loading: true,
      };

    case POST_DASHBOARD_CHECKOUT_RESET:
      return { ...intitialstate, isUpdated: (state as any).isUpdated };
    case POST_DASHBOARD_CHECKOUT_RESET_LOGOUT:
      return intitialstate;

    case POST_CHECKOUT_ACTION_RESET:
      return {
        ...state,
        clockAction: null,
      };

    default:
      return state;
  }
};
